export default __webpack_public_path__ + "assets/images/teenyicons_tick-circle-outline-green.svg";